'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosGlassesOutline = function IoIosGlassesOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.8 19.3h1.2v1.4h-1.2c-0.1 1.7-1 3.4-2.2 4.5-1.4 1.3-3.1 2-4.9 2-4 0-7.2-3.2-7.2-7.2 0-0.8-0.9-1.7-2-1.7s-2 0.9-2 1.7c0 4-3.2 7.2-7.2 7.2-1.8 0-3.5-0.7-4.9-2-1.2-1.1-2.1-2.8-2.2-4.5h-1.2v-1.4h1.2c0.1-1.7 1-3.4 2.2-4.6 1.4-1.3 3.1-1.9 4.9-1.9 3.3 0 6.1 2.1 6.9 5.2 0.6-0.5 1.4-0.9 2.3-0.9s1.7 0.4 2.3 0.9c0.8-3.1 3.6-5.2 6.9-5.2 1.8 0 3.5 0.7 4.9 2 1.2 1.1 2.1 2.8 2.2 4.5z m-7.1 6.7c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6z m-18.4 0c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6z' })
        )
    );
};

exports.default = IoIosGlassesOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-glasses-outline.js
// module id = 2409
// module chunks = 0